export const statuses = [
  { id: "caa35982-0fa8-4093-9793-e4f7a93f637f", name: "Active" },
  { id: "86ef9a32-7086-422d-9e03-726d8eceae0e", name: "Inactive" },
]
